/**
 * Pricing Toggle JavaScript
 * Monthly / Yearly toggle
 */

(function() {
  'use strict';

  function initPricingToggle() {
    const toggle = document.querySelector('[data-pricing-toggle]');
    if (!toggle) return;

    const buttons = toggle.querySelectorAll('.pricing-toggle-btn');
    const prices = document.querySelectorAll('.pricing-price');
    const periods = document.querySelectorAll('.pricing-period');

    buttons.forEach(button => {
      button.addEventListener('click', () => {
        const period = button.getAttribute('data-period');

        // Update button states
        buttons.forEach(btn => {
          if (btn === button) {
            btn.classList.add('active');
            btn.classList.remove('text-muted-foreground', 'hover:text-foreground');
          } else {
            btn.classList.remove('active');
            btn.classList.add('text-muted-foreground', 'hover:text-foreground');
          }
        });

        // Update prices
        prices.forEach(priceEl => {
          const monthlyPrice = priceEl.getAttribute('data-monthly');
          const yearlyPrice = priceEl.getAttribute('data-yearly');

          if (period === 'yearly' && yearlyPrice) {
            priceEl.textContent = '€' + yearlyPrice;
          } else if (monthlyPrice) {
            priceEl.textContent = '€' + monthlyPrice;
          }
        });

        // Update periods
        periods.forEach(periodEl => {
          periodEl.textContent = period === 'yearly' ? '/jaar' : '/maand';
        });
      });
    });
  }

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPricingToggle);
  } else {
    initPricingToggle();
  }
})();

